function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Flag Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.535714286,0.497357143 C0.831581116,0.497357143 1.07142857,0.737204598 1.07142857,1.03307143 L1.07142857,1.03307143 L1.071,1.62635714 L13.3928571,1.62717857 C13.8336925,1.62717857 14.0858494,2.12991839 13.8222318,2.48324766 L11.0638879,6.18028285 L13.8222706,9.87830435 C14.0858276,10.2316416 13.8336626,10.7343214 13.3928571,10.7343214 L1.071,10.7333571 L1.07142857,18.9548571 C1.07142857,19.2211373 0.877152133,19.4420417 0.622609925,19.4835598 L0.535714286,19.4905714 C0.239847455,19.4905714 0,19.250724 0,18.9548571 L0,18.9548571 L0,1.03307143 C0,0.737204598 0.239847455,0.497357143 0.535714286,0.497357143 Z M12.3247726,2.69860714 L1.07142857,2.69860714 L1.07142857,9.66289286 L12.324934,9.66289286 L9.9661145,6.50054517 C9.8243657,6.31050986 9.82438149,6.04990571 9.9661533,5.85988757 L12.3247726,2.69860714 Z",
  id: "flag-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "flag-Icon/Global/Issue",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "flag-Swatches/Midnight",
  transform: "translate(5.500000, 2.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "flag-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#flag-path-1"
})));

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.e350aa4b.svg";
export { ForwardRef as ReactComponent };